<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/150kW-M/150kW-M.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">150kW多合一电驱总成</div>
                <div class="detail-banner-desc transmission">
                    Motor+MCU+VCU+GearBox+OBC+DCDC+PDU 多合一电驱总成
                    <div class="detail-desc">
                        <div>
                            集成了MCU&VCU、电机、减速器、OBC、DCDC、PDU、兼容EVCC；<br />
                        </div>
                        <div>
                            总成布局一体轴设计实现超小体积451*437*339mm，多项全域提效技术，实现CLTC工况效率≥90%；<br />
                        </div>
                        <div>
                            软件5合1集成了整车控制、自适应热管理、智能电源管理、AI智能云诊断、主动加热、冗余虚拟传感（定转子温度估算、旋变位置估算）等功能；<br />
                        </div>
                        <div>
                            电源采用全SiC高效率功率器件，支撑6kVA V2V、V2L放电及智能充电技术，对外放电过程的高压安全监测技术。
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/150kW-M/150kW-M-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">150kW</div>
                                    <div class="k">电机峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">20000rpm</div>
                                    <div class="k">电机峰值转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3450N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">油冷</div>
                                    <div class="k">电机冷却</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">451*437*339</div>
                                    <div class="k">电桥尺寸 X*Y*Z（mm）</div>
                                </div>
                                
                                <div class="spec-item">
                                    <div class="v">6.6kW</div>
                                    <div class="k">OBC功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3kW</div>
                                    <div class="k">DCDC功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">79kg</div>
                                    <div class="k">重量</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '150kW多合一电驱总成 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/150-m.html'
};

import { createApp } from 'vue';
import App from './150-m.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./150-m.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
